<template lang="pug">
.btn-group.select-shop
    a.btn.btn-wide.btn-default.dropdown-toggle(
        data-toggle="dropdown", 
        aria-haspopup="true", 
        aria-expanded="true"
    ) {{ trimScheme(selectedShop.domain) }}  
        span.caret
    
    ul.dropdown-menu.dropdown-light(role='menu', x-placement='bottom-start')
        template(v-for="shop in shops")
            a.dropdown-item(
                v-if="shop.number != selectedShop.number", 
                @click.prevent="selectShop(shop)",
                href=".navbar-collapse",
                data-toggle="collapse"
            ) {{ trimScheme(shop.domain) }} 
        a.dropdown-item(
            v-if="shops.length < maxShops", 
            @click.prevent="createShop",
            href=".navbar-collapse",
            data-toggle="collapse"
        ) Добавить магазин
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'SelectShop',
    methods: {
        selectShop(shop) {
            this.$store.commit('selectShop', shop);

            const activeComponent = this.$router.currentRoute.matched[0].instances.default;
            activeComponent.getDataHook && activeComponent.getDataHook();
        },
        createShop() {
            if (this.$router.currentRoute.name == 'EditShop') {
                const activeComponent = this.$router.currentRoute.matched[0].instances.default;
                activeComponent.setEmptyShop();
            } else {
                this.$router.push({name: 'EditShop', params: {isNew: true}});
            }
        },
        trimScheme(domain) {
            return domain && domain.replace(/^http[s]{0,1}:\/\//, '');
        }
    },
    computed: {
        ...mapState({
            selectedShop: state => state.localStorage.selectedShop,
            maxShops: state => state.users.profile.max_shops
        }),
        ...mapGetters(['shops'])
    }
};
</script>

<style>
.select-shop {
    margin-top: 15px;
}
.select-shop .btn {
    padding-right: 15px;
    padding-left: 15px;
}
.select-shop .dropdown-menu {
    position: absolute; 
    transform: translate3d(0px, 35px, 0px); 
    top: 0px; 
    left: 0px; 
    will-change: transform;
}
.select-shop .dropdown-item {
    padding-left: 15px;
    padding-right: 15px;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectShop.vue